export enum BranchServiceMode {
  MENU_ONLY = 1,
  MENU_AND_ORDER = 2,
  MENU_ORDER_AND_PAYMENT = 3,
  MENU_AND_PAYMENT = 4,
}
